import React, { Suspense, lazy } from 'react';
import MainLoader from '~components/main-loader';

const StatisticsPage = lazy(() => import('./index.js'));

function StatisticsItemPageLazy(props) {
    return (
        <Suspense fallback={<MainLoader />}>
            <StatisticsPage {...props} />
        </Suspense>
    );
}

export default StatisticsItemPageLazy;
export { StatisticsItemPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/statistics-item-page/lazy.js